module.exports = __webpack_public_path__ + "static/media/web.96b55b02.png";